// @flow
import * as React from 'react';

export default function CalendarHints({ enableTrackFlight }) {
  return (
    <div className="calendar-statuses calendar-statuses-hints">
      <div>
        <span className="calendar-status not-started">
          <span className="icon plane-earth" /> 12:00 AM <b>JZ</b> #1234
        </span>{' '}
        - Not Started
      </div>
      <div>
        <span className="calendar-status not-started waiting">
          <span className="icon plane-earth" /> 12:00 AM <b>JZ</b> #1234
        </span>{' '}
        - Waiting (Not Started)
      </div>
      <div>
        <span className="calendar-status in-progress">
          <span className="icon__new icon-plane-check-out" /> 12:00 AM <b>JZ</b> #1234
        </span>{' '}
        - In progress (Checked Out)
      </div>
      {enableTrackFlight && (
        <div>
          <div>
            <span className="calendar-status overdue">
              <span className="icon__new icon-plane-overdue" /> 12:00 AM <b>JZ</b> #1234
            </span>{' '}
            - Overdue (more than 10 minutes)
          </div>
          <div>
            <span className="calendar-status overdue">
              <span className="icon__new icon-plane-overdue overdue-low" /> 12:00 AM <b>JZ</b> #1234
            </span>{' '}
            - Overdue (less than 10 minutes)
          </div>
        </div>
      )}
      <div>
        <span className="calendar-status completed">
          <span className="icon__new icon-plane-complete" /> 12:00 AM <b>JZ</b> #1234
        </span>{' '}
        - Completed (Checked In)
      </div>
      <div>
        <span className="calendar-status maintenance">
          <span className="icon maintenance" /> 12:00 AM #1234567
        </span>{' '}
        - Maintenance (Not Started)
      </div>
      <div>
        <span className="calendar-status maintenance in-air">
          <span className="icon maintenance" /> 12:00 AM #1234567
        </span>{' '}
        - Maintenance In Progress (Checked Out)
      </div>
      <div>
        <span className="calendar-status maintenance completed">
          <span className="icon maintenance" /> 12:00 AM #1234567
        </span>{' '}
        - Maintenance Completed (Checked In)
      </div>
    </div>
  );
}
